import { useCompatAnyModalOpen } from '@fabric-app/compat';
import { useIsAnyRadixModalOpenCount } from './useIsAnyRadixModalOpened.js';

const useIsAnyModalOpen = () => {
  const compatModalOpen = useCompatAnyModalOpen();
  const radixModalsCount = useIsAnyRadixModalOpenCount();
  return compatModalOpen || radixModalsCount > 0;
};

export { useIsAnyModalOpen };
//# sourceMappingURL=useIsAnyModalOpen.js.map
